import { VueConstructor } from 'vue';
import { CoreOptions } from '../../../src';
import IModule from '../../module';
import eventWidgetsModule from './events';

export default {
  async loadModule(options: CoreOptions, vue: VueConstructor) {
    eventWidgetsModule.loadModule(options, vue);
  },
  async unloadModule(options: CoreOptions, vue: VueConstructor) {
    eventWidgetsModule.unloadModule(options, vue);
  },
} as IModule;
